import {
    GET_CONFIG_FORM26,    
    GET_DATOS_SOLICITUD
    
} from '../types';

export default function SolicitudDescuentoReducer(state = {}, action) {
    switch (action.type) {
        case GET_CONFIG_FORM26:
            return { ...state, cfg_form26:action.payload }
        case GET_DATOS_SOLICITUD:
            return { ...state, datosSolicitud:action.payload }
       
       
       
        default:
            return state
    }
}